import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// project-imports
import { handleDiscountedPrice } from "../../utils/course";
import { useUserContext } from "../../context/user_context";
import { useOrderContext } from "../../context/order_context";
import Spinner from "../spinner-component/SpinnerThree";
import { PaymentSuccessModel } from "../success-model/PaymentSuccessModel";
import ToolTip from "../../common/Tooltip/ToolTip";
import ModalLogin from "../form/ModalLogin";
import {
    GoogleAnalyticsEnum,
    triggerFunction,
} from "../../utils/google-analytics";
import { useProductContext } from "../../context/product_context";
import EBookDrawer from "./EBookDetailDrawer";
import { showToast } from "../sweet-alert/Sweetalert";
import { TestimonialForm } from "../form/TestimonialForm";
import ProductRatingData from "../../data/Products/ProductRating.json";
import EbookStarRating from "./EbookStarRating";
import FsLightbox from "fslightbox-react";
import GenericPdfViewer from "../../pages/blogMedia/GenericPdfViewerTwo";

// third-party
import moment from "moment";
import Avatar from "react-avatar";
import { FaRegFilePdf } from "react-icons/fa";
import { slugify } from "../../utils";

// Reading env variable
const VENDOR_NAME = process.env.REACT_APP_RAZOR_APP_VENDOR_NAME;
const RAZOR_THEME = process.env.REACT_APP_RAZOR_APP_THEME_COLOR;

const EBookListingOne = ({ data, classes, activeStatus, bgWhite, code }) => {
    // reading context variables and methods
    const { loginData } = useUserContext();
    const {
        fetchOrders,
        orderLoading,
        createOrders,
        isPaymentSuccess,
        closePaymentSuccessModal,
        downloadEbook,
        ordersError,
    } = useOrderContext();
    const { productLoading } = useProductContext();
    const navigate = useNavigate();

    //  local stat initialization
    const [openDrawer, setOpenDrawer] = useState(code ? true : false);
    const [openReview, setOpenReview] = useState(false);
    const [notLoggedIn, setNotLoggedIn] = useState(false);
    const [selectedProductCode, setSelectedProductCode] = useState(null);
    const [showTestimonialModal, setShowTestimonialModal] = useState(false);
    const [newOrder, setNewOrder] = useState({});
    const [toggler, setToggler] = useState(false);

    // constant variable
    const member =
        loginData && loginData?.data && loginData?.data?.userId
            ? loginData?.data
            : [];
    const metaTags =
        data && data?.metadata && data?.metadata?.tags
            ? (data?.metadata?.tags || "")?.split(",")?.slice(0, 2)
            : [];
    const selectedProduct =
        (code || selectedProductCode) &&
            (data?.productCode || "")?.toLowerCase() ===
            (code || selectedProductCode || "")?.toLowerCase()
            ? data
            : null;
    // const isDiscountValid = data && data?.discount && data?.discount?.hasDiscount && handleDiscountedPrice(data)?.isValid;

    const userReviewsList = ProductRatingData || [];

    const reviews =
        data && data?.metadata && data?.metadata?.ratings && data?.metadata?.ratings !== "0"
            ? data?.metadata?.ratings
            : "[]";

    // this will remove the tralling commas as there is the comma that making error on pars so used this to clean the string
    let cleanString = reviews?.replace(/,\s*([}\]])/g, "$1");
    const review = JSON.parse(cleanString);

    // Get instructor ID
    const instructorId = process.env.REACT_APP_AUTHOR_ID;
    const instructorName = data?.metadata?.authorName;
    const instructorThumb = `${process.env.PUBLIC_URL}/images/instructor/${process.env.REACT_APP_AUTHOR_IMAGE}`;

    // Get Preview URL
    const previewPath = data && data?.media && data?.media?.previewUrl ? data?.media?.previewUrl : "#";
    const filePath = `${process.env.PUBLIC_URL}/ebook-preview/${previewPath}`
    const previewName = data && data?.name ? data?.name : "Free Preview";


    // constant functions
    const handleOpenDrawer = (productCode) => {
        try {
            setOpenDrawer(true);
            setSelectedProductCode(productCode);
            navigate(
                `/our-resources/${activeStatus}/${code ? code : (productCode || "")?.toLowerCase()
                }`
            );
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DETAIL_VIEWED
            );
        } catch (error) {
            console.log(
                "89 : EBookListingOne : Error in handleOpenDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    const handleOpenUserReview = (productCode) => {
        try {
            // setOpenDrawer(true);
            setSelectedProductCode(productCode);
            navigate(
                `/our-resources/${activeStatus}/${code ? code : (productCode || "")?.toLowerCase()
                }#reviews`
            );
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DETAIL_VIEWED
            );
        } catch (error) {
            console.log(
                "89 : EBookListingOne : Error in handleOpenDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    const handleHideDrawer = () => {
        try {
            setOpenDrawer(false);
            navigate(`/our-resources/${activeStatus}`);
        } catch (error) {
            console.log(
                "101 : EBookListingOne : Error in handleHideDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    const handleOpenReview = () => setOpenReview(true);
    const handleCloseReview = () => setOpenReview(false);

    const toggleTestimonialModal = () => {
        try {
            setShowTestimonialModal(!showTestimonialModal);
        } catch (error) {
            console.error(
                "114 : TestimonialForm : Error occurred in toggleTestimonialModal:",
                error && JSON.stringify(error)
            );
            showToast(
                "error",
                "Something went wrong while toggling the testimonial modal. Please try again.",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
        }
    };
    const togglePreviewModal = () => {
        try {
            setToggler(!toggler);
        } catch (error) {
            console.error(
                "179 : EBookTypeOne : Error occurred in togglePreviewModal:",
                error && JSON.stringify(error)
            );
            showToast(
                "error",
                "Something went wrong while toggling the preview modal. Please try again.",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
        }
    }

    const isDiscountValid = (data) => {
        try {
            if (
                data &&
                data?.discount &&
                data?.discount?.hasDiscount &&
                handleDiscountedPrice(data)?.isValid
            ) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log(
                "62 : EBookListingOne : Error in isDiscountValid : ",
                error && JSON.stringify(error)
            );
        }
    };
    const eBookAmount =
        data && isDiscountValid(data)
            ? handleDiscountedPrice(data)?.finalAmount * 100
            : data?.pricing?.priceInSmallUnit || 501;
    const eBookDiscount =
        data && isDiscountValid(data)
            ? parseFloat(data?.discount?.discountPercent || "0.00")
            : "0.00";

    const handleDownloadBook = async (data) => {
        try {
            if (!member || (member && !member?.userId)) {
                setNotLoggedIn(true);
                return;
            }
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DOWNLOAD_BUTTON
            );
            const orderPayload = {
                amount: activeStatus === "free" ? 501 : eBookAmount,
                amountUnit: "paise",
                discount: eBookDiscount,
                orderCurrency: data?.pricing?.priceCurrency || "INR",
                receipt: `${activeStatus}_lsa_portal_order_${Date.now()}`,
                amountPaid: 0.0,
                createdAt: moment(new Date()).format("YYYY-MM-DD"),
                vendorName: VENDOR_NAME,
                customer: {
                    customerId: member?.firebaseUid || member?.userRecordId,
                    email: member?.userId,
                    fullName: member?.userFullName,
                },
                notes: [
                    {
                        id: data?.id,
                        productCode: data?.productCode,
                        name: data?.name,
                        type: data?.type,
                        duration: data?.pricing?.billingCycle,
                        isActive: data?.isActive,
                        category: data?.category,
                        subCategory: data?.subCategory,
                        // description: data?.description,
                        description: "Purchase Of - " + (data?.name || ""),
                        price: eBookAmount,
                        discountPercent: eBookDiscount,
                        features: data?.features,
                        thumbnailUrl: data?.media?.thumbnailUrl || "#",
                    },
                ],
            };

            if (activeStatus === "free") {
                setNewOrder(orderPayload);
                // calling create order api
                const response = await createOrders(orderPayload);
                if (!ordersError && response !== "error") {
                    downloadEbook({
                        paymentId: response?.razorPayOrderId,
                        productId: data?.productCode,
                        productName: data?.name,
                        entityType: "free",
                    });

                    //Open Testimonial Modal
                    // toggleTestimonialModal();
                    // setShowTestimonialModal((prev) => !prev);
                }
            }
            if (activeStatus === "paid") {
                // calling create order api
                const response = await createOrders(orderPayload);

                // Addded this

                if (!ordersError && response !== "error") {
                    const options = {
                        key: process.env.REACT_APP_RAZOR_APP_KEY,
                        order_id: response?.razorPayOrderId,
                        amount: eBookAmount,
                        currency: data?.currency,
                        name: VENDOR_NAME,
                        // description: data?.description,
                        description: "Purchase Of - " + (data?.name || ""),
                        image: process.env.REACT_APP_LOGO_URL,
                        handler: function (response) {
                            setNewOrder({
                                ...newOrder,
                                ...orderPayload,
                                paymentId: response.razorpay_payment_id,
                            });
                            // alert(
                            //     'Payment Successful! Payment ID: ' +
                            //     response.razorpay_payment_id
                            // )

                            downloadEbook({
                                paymentId: response?.razorpay_payment_id,
                                productId: data?.productCode,
                                productName: data?.name,
                                entityType: "",
                            });
                            //Open Testimonial Modal
                            // toggleTestimonialModal();
                            // setShowTestimonialModal((prev) => !prev);
                        },
                        prefill: {
                            name: member?.userFullName,
                            email: member?.userId,
                            contact: "",
                        },
                        theme: {
                            color: RAZOR_THEME,
                        },
                        notify: {
                            sms: true,
                            email: true,
                        },
                        notes: {
                            item_description: "Purchase Of - " + (data?.name || ""),
                            // item_description: data?.description, // You can add item details here as well
                        },
                    };
                    const rzp = new window.Razorpay(options);
                    rzp.open();
                }
            }
        } catch (error) {
            console.log(
                "145 : EBookListingOne : Error in handleDownloadBook : ",
                error && JSON.stringify(error)
            );
        }
    };

    const isPaymentDone = () => {
        if (isPaymentSuccess && newOrder && Object.keys(newOrder).length) {
            return true;
        }
    };

    const closeModalLogin = () => setNotLoggedIn(false);

    const closeModalPaymentSuccess = () => {
        try {
            closePaymentSuccessModal();
        } catch (error) { }
    };

    // TODO: 09242026 - Commented this
    // useEffect(() => {
    //     if (member && member?.userId) {
    //         const userUniqueId = member && ((member?.firebaseUid ? member?.firebaseUid : member?.userRecordId));

    //         fetchOrders(userUniqueId);
    //     }
    // }, [orderLoading, member]);

    return (
        <>
            {(orderLoading || productLoading) && <Spinner />}

            <div className={`edu-card card-type-4 radius-small eduvibe-course-style-four ${classes ? classes : ''} ${bgWhite === 'enable' ? 'bg-white' : ''}`}>
                <div className="inner">
                    <div className="thumbnail">
                        <img
                            className="w-100 clickable"
                            src={`${process.env.PUBLIC_URL}/images/ebooks/${data?.media?.thumbnailUrl}`}
                            alt={data?.name}
                            onClick={() => handleOpenDrawer(data?.productCode)}
                        />
                        {/* <div className="wishlist-top-right">
                            <div className="wishlist-btn"><i className="icon-Heart"></i></div>
                        </div> */}

                        <div className="center-position status-group left-top m-0">
                            <a href={"#"} onClick={(e) => {
                                e.preventDefault();
                                setToggler(prev => !prev);
                            }} className="underline">
                                <span className="eduvibe-status status-04 badge-preview">Watch Preview</span>
                            </a>
                        </div>


                        {isDiscountValid(data) && (
                            <div className="wrap-resource text-center">
                                <span className="ribbon-bottom fs-5 fw-bold text-center">
                                    {data?.discount?.discountPercent}% Off
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="content">
                        <div className="card-top flex-row">
                            <div className="author-meta">
                                <div className="author-thumb">
                                    {instructorName && instructorThumb && instructorId ?
                                        <Link to={process.env.PUBLIC_URL + `/instructor-details/${instructorId}`}>
                                            <Avatar className="custom-avatar" name={instructorName} size={34} round={true} src={instructorThumb ? instructorThumb : ''} />
                                            <span className="author-title">{instructorName}</span>
                                        </Link>
                                        : <Link to="#">
                                            <Avatar className="custom-avatar" name={"No Instructor"} size={34} round={true} src="" color="#525FE1" />
                                            <span className="author-title">No Instructor</span>
                                        </Link>
                                    }
                                </div>
                            </div>

                            {/* <div className="wishlist-top-right">
                                <div className="wishlist-btn"><i className="icon-Heart"></i></div>
                            </div> */}
                        </div>
                        <ul className="edu-meta meta-03">
                            <li className="meta-lessons">
                                <ToolTip title={"Document Type"}>
                                    <FaRegFilePdf className="icon" />
                                </ToolTip>
                                PDF
                            </li>
                            <li className="meta-clock text-capitalize">
                                <ToolTip title={"Pages"}>
                                    <i className="icon-Open-book"></i>
                                </ToolTip>
                                {data?.metadata?.pages || 0}
                            </li>
                            <li className="meta-user text-capitalize">
                                <ToolTip title={"Downloads"}>
                                    <i class="ri-download-line"></i>
                                </ToolTip>
                                {data?.metadata?.downloads || 0}
                            </li>
                        </ul>
                        <h6 className="title">
                            <ToolTip title={data?.name}>
                                <Link
                                    dangerouslySetInnerHTML={{ __html: data?.name }}
                                    to={`/our-resources/${activeStatus}/${(data?.productCode?.toLowerCase() || "")}`}
                                ></Link>
                            </ToolTip>
                        </h6>

                        <div className="card-bottom">
                            <div className="price-list price-style-03">
                                {!data?.pricing?.price || data?.pricing?.price <= 0 ? (
                                    <div className="price current-price-free">Free</div>
                                ) : (
                                    <div className="price current-price">
                                        {isDiscountValid(data)
                                            ? handleDiscountedPrice(data)?.formattedAmount
                                            : data?.pricing?.priceFormatted}
                                    </div>
                                )}
                                {isDiscountValid(data) && (
                                    <div className="price old-price">
                                        {data.pricing?.priceFormatted}
                                    </div>
                                )}
                            </div>
                            <div className="edu-rating rating-default">
                                <div className="rating eduvibe-course-rating-stars">
                                    <EbookStarRating reviews={review} onViewUserRatings={review?.length ? () => handleOpenUserReview(data?.productCode) : null} />
                                </div>
                            </div>
                        </div>

                        <div className="card-bottom">
                            <div className="">
                                <button
                                    className="edu-btn btn-primary btn-small mx-1 fs-5"
                                    onClick={() => handleDownloadBook(data)}
                                >
                                    <i className="ri-download-line p-0"></i> Download
                                </button>
                            </div>
                            <div className="">
                                <div className="rating eduvibe-course-rating-stars">
                                    <button
                                        className="edu-btn btn-primary btn-border btn-small mx-1 fs-5"
                                        onClick={toggleTestimonialModal}
                                    >
                                        <i className="ri-eye-line p-0 me-2"></i> Add Review
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* {selectedProduct && (
                <EBookDrawer
                    show={openDrawer}
                    classes={classes}
                    bgWhite={bgWhite}
                    onClose={handleHideDrawer}
                    onViewUserRatings={handleOpenUserReview}
                    onAddReview={toggleTestimonialModal}
                    data={selectedProduct}
                    title={"E-Book Info"}
                    onDownloadClick={handleDownloadBook}
                    isLoading={orderLoading || productLoading}
                    handleShowTestimonialModal={toggleTestimonialModal}
                />
            )} */}

            <ModalLogin
                show={notLoggedIn}
                onCloseModalLogin={closeModalLogin}
                title={"Login to proceed action"}
            />

            {isPaymentDone() && (
                <PaymentSuccessModel
                    show={isPaymentSuccess}
                    onCloseModal={closeModalPaymentSuccess}
                    response={newOrder}
                />
            )}

            {showTestimonialModal && (
                <TestimonialForm
                    show={showTestimonialModal}
                    data={data}
                    onCloseModal={toggleTestimonialModal}
                    title={"Submit Review"}
                />
            )}
            {/* <FsLightbox toggler={toggler} sources={[previewUrl]} /> */}
            <GenericPdfViewer data={{ url: filePath, title: previewName }} show={toggler} onCloseModal={togglePreviewModal} />
        </>
    );
};

export default EBookListingOne;
